export default "__VITE_ASSET__o6W9z8GV__"